/**
 * Fond de repli d'une section et de ses colonnes, quand rien n'a été choisi.
 *
 * Le blanc, et non la couleur de fond de l'e-mail : les sections se posent *sur* ce fond, et une
 * section de sa couleur ne se distinguerait plus du corps du message.
 */
export const EMAIL_DEFAULT_BG_COLOR = '#ffffff';
